module.exports = __webpack_public_path__ + "static/img/zhihui.764aba2f.png";